module.exports = __webpack_public_path__ + "static/media/fox-news.05768b3a.jpg";